import type PartySocket from "partysocket";

import { CallTestingPanel } from "../Testing/CallTestingPanel";
import { CallProvider, useCallContext } from "./CallContext";
import { CallDisplayUI } from "./CallDisplayUI";
import { TestPortal } from "./CallManagerWrapper";

export function CallDisplay({
  mainSocket,
  roomId,
  leaveCall,
}: Readonly<{
  mainSocket: PartySocket;
  roomId: string;
  leaveCall: () => void;
}>) {
  return (
    <CallProvider roomId={roomId} leaveCall={leaveCall} mainSocket={mainSocket}>
      <CallDisplayContent />
    </CallProvider>
  );
}

function CallDisplayContent() {
  const { reconnectAttempt, transcript, botSocket, scriptDetectionLogs } =
    useCallContext();

  return (
    <>
      <CallDisplayUI key={reconnectAttempt} />
      <TestPortal>
        <CallTestingPanel
          botSocket={botSocket}
          transcript={transcript}
          scriptDetectionLogs={scriptDetectionLogs}
        />
      </TestPortal>
    </>
  );
}
